const mediaItems = [
  {
    title: '韩漫推荐：2024年必追恋爱神作',
    desc: '精选十部口碑爆棚的韩漫恋爱作品，从契约婚姻到办公室恋情，每部都是让读者欲罢不能的高甜神作。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20reading%20interface%20style%2C%20beautiful%20character%20illustrations%20on%20digital%20screen%2C%20warm%20pink%20and%20coral%20color%20scheme%2C%20soft%20romantic%20atmosphere%2C%20clean%20modern%20UI%20design%2C%20editorial%20quality%2C%20comic%20reading%20app%20interface%20mockup&width=640&height=400&seq=qinqin-media-01&orientation=landscape',
    tag: '韩漫特辑',
  },
  {
    title: '日漫经典：异世界冒险漫画大盘点',
    desc: '从剑与魔法到科幻穿越，日漫异世界题材经久不衰。本期盘点当下最火爆的异世界冒险漫画，带你进入奇幻之旅。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20fantasy%20adventure%20manga%20collection%20display%2C%20colorful%20manga%20covers%20arranged%20on%20shelf%2C%20warm%20amber%20and%20golden%20lighting%2C%20cozy%20reading%20room%20setting%2C%20editorial%20quality%2C%20manga%20collection%20display%20aesthetic&width=640&height=400&seq=qinqin-media-02&orientation=landscape',
    tag: '日漫精选',
  },
  {
    title: '国漫崛起：这些修仙漫画值得一读',
    desc: '国漫近年迎来爆发期，修仙题材尤为亮眼。精选当下最受欢迎的国漫修仙作品，感受东方奇幻的独特魅力。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cultivation%20fantasy%20art%20style%2C%20ethereal%20mountain%20landscape%20with%20floating%20characters%20in%20flowing%20robes%2C%20traditional%20ink%20painting%20with%20modern%20digital%20art%20fusion%2C%20soft%20jade%20green%20and%20golden%20color%20palette%2C%20editorial%20quality&width=640&height=400&seq=qinqin-media-03&orientation=landscape',
    tag: '国漫特辑',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-12 md:py-16 bg-background-100/50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 text-center mb-8">
          精选专题
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <a
              key={item.title}
              href="#"
              onClick={(e) => e.preventDefault()}
              className="group cursor-pointer rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/50 transition-all"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-secondary-100/50">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`亲亲漫画 ${item.tag} - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3 px-3 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-medium text-foreground-800">
                  {item.tag}
                </div>
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <i className="ri-play-circle-fill text-primary-500 text-2xl"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}